import React from "react";
import ReactDOMClient from "react-dom/client";
import { WeightLoss} from "./WeightLoss";
import '../../../utils/i18next';
import '../../../utils/debug'; // 导入debug工具，自动绑定到window
import '../../../tailwind.css';
import '../../../styles/ripple.css';

const app = document.getElementById("root");
const root = ReactDOMClient.createRoot(app);
root.render(<WeightLoss />);
